export default __webpack_public_path__ + "static/media/about-us-img-1.6c9e4abd.jpg";